import * as moment from 'moment';
import {isNullOrUndefined} from 'util';
import {FormControl, FormGroup, Validators} from '@angular/forms';

export class CambioClass {
    form: FormGroup;
    public id: number = null;
    public cajaDeCambios:boolean = null;
    public numeroVelocidades:boolean = null;
    public automatica:boolean = null;


    constructor(data: any = null) {
        if (!isNullOrUndefined(data))
            Object.keys(data).map(i => this[i] = data[i]);

        this.form = new FormGroup({
            id: new FormControl(this.id),
            cajaDeCambios: new FormControl({value: this.cajaDeCambios, disabled: false}),
            numeroVelocidades: new FormControl({value: this.numeroVelocidades, disabled: false}),
            automatica: new FormControl({value: this.automatica, disabled: false})
        });
    }
}
